module.exports = __webpack_public_path__ + "img/InCopyright-NonCommercial.93e10d28.png";